export const devOnlyNodeIds = new Set([
  "2.3", // Production Order Optimization
  "6.1.5", // Data Management
  "6.3", // Support Section
  "6.3.1", // Debug Test Functions
  "6.3.2", // Browser Info
  "6.3.3", // Backup Restore
]);

export const superAdminOnlyNodeIds = new Set([
  "2.1", // Production Orders — vendor/SuperAdmin debug view only
]);

export const devFeaturesEnabled =
  import.meta.env.VITE_ENABLE_DEV_FEATURES === "true" ||
  import.meta.env.MODE === "development";

export const isDevOnlyRoute = (nodeId: string) => devOnlyNodeIds.has(nodeId);

export const isSuperAdminOnlyRoute = (nodeId: string) => superAdminOnlyNodeIds.has(nodeId);
